import {
    Edit,
    NumberInput,
    SelectInput,
    SimpleForm,
    TextInput
} from '@/components/admin';
import { ShieldCheck } from 'lucide-react';

// accepted + rejected must not exceed the received quantity
const validateQa = (values: any) => {
    const errors: Record<string, string> = {};
    const received = Number(values?.received_qty) || 0;
    const accepted = Number(values?.accepted_qty) || 0;
    const rejected = Number(values?.rejected_qty) || 0;
    if (accepted < 0) errors.accepted_qty = 'Cannot be negative';
    if (rejected < 0) errors.rejected_qty = 'Cannot be negative';
    if (accepted + rejected > received) {
        errors.accepted_qty = 'Accepted + Rejected cannot exceed Received';
        errors.rejected_qty = 'Accepted + Rejected cannot exceed Received';
    }
    return errors;
};

export const GRNItemEdit = () => {
    return (
        <Edit title="Inspect Received Item" redirect={(_r: any, _id: any, data: any) => `goods_receipts/${data?.grn_id}/show`}>
            <SimpleForm className="max-w-xl" validate={validateQa}>
                <div className="mb-6 flex items-center gap-2 text-slate-800">
                    <ShieldCheck className="w-5 h-5 text-slate-500" />
                    <h3 className="text-lg font-bold">QA Inspection</h3>
                </div>

                <TextInput source="grn_id" disabled className="hidden" />
                <TextInput source="po_item_description" label="Item" disabled className="w-full" />

                <div className="grid grid-cols-2 gap-4 w-full">
                    <NumberInput source="ordered_qty" label="Ordered Qty" disabled />
                    <NumberInput source="received_qty" label="Received Qty" isRequired />

                    <NumberInput source="accepted_qty" label="Accepted Qty" helperText="Quantity that passed QA" />
                    <NumberInput source="rejected_qty" label="Rejected Qty" helperText="Quantity rejected / to return" />
                </div>

                <SelectInput source="qa_status" label="QA Status" choices={[
                    { id: 'pending', name: 'Pending' },
                    { id: 'passed', name: 'Passed' },
                    { id: 'failed', name: 'Failed' },
                ]} />
            </SimpleForm>
        </Edit>
    );
};
